// extracted by mini-css-extract-plugin
export var chevron = "_x-d";
export var disabled = "_x-b";
export var error = "_x-c";
export var hideBorder = "_x-1";
export var icon = "_x-e";
export var input = "_x-0";
export var large = "_x-f";
export var open = "_x-9";
export var placeholder = "_x-a";
export var regular = "_x-5";
export var singleRowInput = "_x-2";
export var singleSelectInput = "_x-3 _x-0";
export var small = "_x-4";
export var spinnerContainer = "_x-i";
export var tag = "_x-7";
export var tagsContainer = "_x-8";
export var tagsInput = "_x-6 _x-0";
export var xSmall = "_x-g";
export var xxSmall = "_x-h";